import clsx from 'clsx'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBell
} from '@fortawesome/free-solid-svg-icons';
import SAISVG, { toAbsoluteUrl } from "../../../helpers/CommonFunction";
import { HeaderNotificationsMenu } from '../../../partials/layout/header-menus/HeaderNotificationsMenu';
import HeaderUserMenu from '../../../partials/layout/header-menus/HeaderUserMenu';
import { useLayout } from '../../core/LayoutProvider';

const item_class = 'ms-1 ms-lg-3'

const userAvatar_class = 'symbol-35px symbol-md-40px'
const btnIcon_class = 'svg-icon-1'

const Navbar = () => {
    const { config } = useLayout()
    return (
        <div className='app-navbar flex-shrink-0'>
            

            <div className={clsx('app-navbar-item', item_class)}>
                <button 
                    className="btn btn-light btn-active-primary btn-icon btn-sm position-relative me-5"
                    data-sai-menu-trigger="{default: 'click'}"
                    data-sai-menu-attach='parent'
                    data-sai-menu-placement='bottom-end'
                >
                    <FontAwesomeIcon className='fs-4' icon={faBell} /> 
                    <span className="position-absolute top-0 start-100 translate-middle  badge badge-circle badge-info">5</span>
                </button>
                <HeaderNotificationsMenu />
            </div>

            <div className={clsx('app-navbar-item', item_class)}>
                <div
                    className={clsx('cursor-pointer symbol', userAvatar_class)}
                    data-sai-menu-trigger="{default: 'click'}"
                    data-sai-menu-attach='parent'
                    data-sai-menu-placement='bottom-end'
                >
                    <img src={toAbsoluteUrl('media/avatars/300-1.jpg')} alt='' />
                </div>
                <HeaderUserMenu />
            </div>

            {config.app?.header?.default?.menu?.display && (
                <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
                    <div
                        className='btn btn-icon btn-active-color-primary w-35px h-35px'
                        id='sai_app_header_menu_toggle'
                    >
                        <SAISVG path='media/icons/duotune/text/txt001.svg' className={btnIcon_class} />
                    </div>
                </div>
            )}
        </div>
    )
}

export default Navbar;